module.exports = __webpack_public_path__ + "static/media/monopoly@2x.2a7c8aec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/aia/monopoly@2x.jpg
// module id = 239
// module chunks = 0